export default {
  DESKTOP_SCREEN_WIDTH_1200: 1200,
  MOBILE_SCREEN_WIDTH: 568,
};
